


  import dep0 from "@ember-data/adapter/-embroider-implicit-modules.js";
  import dep1 from "@ember-data/graph/-embroider-implicit-modules.js";
  import dep2 from "@ember-data/json-api/-embroider-implicit-modules.js";
  import dep3 from "@ember-data/legacy-compat/-embroider-implicit-modules.js";
  import dep4 from "@ember-data/model/-embroider-implicit-modules.js";
  import dep5 from "@ember-data/request/-embroider-implicit-modules.js";
  import dep6 from "@ember-data/request-utils/-embroider-implicit-modules.js";
  import dep7 from "@ember-data/serializer/-embroider-implicit-modules.js";
  import dep8 from "@ember-data/store/-embroider-implicit-modules.js";
  import dep9 from "@ember/test-helpers/-embroider-implicit-modules.js";
  import dep10 from "@ember/test-waiters/-embroider-implicit-modules.js";
  import dep11 from "@embroider/legacy-inspector-support/-embroider-implicit-modules.js";
  import dep12 from "@embroider/router/-embroider-implicit-modules.js";
  import dep13 from "@glimmer/component/-embroider-implicit-modules.js";
  import dep14 from "@warp-drive/core-types/-embroider-implicit-modules.js";
  import dep15 from "@warp-drive/ember/-embroider-implicit-modules.js";
  import dep16 from "ember-cli-babel/-embroider-implicit-modules.js";
  import dep17 from "ember-data/-embroider-implicit-modules.js";
  import dep18 from "ember-intl/-embroider-implicit-modules.js";
  import dep19 from "ember-modifier/-embroider-implicit-modules.js";
  import dep20 from "ember-page-title/-embroider-implicit-modules.js";
  import dep21 from "ember-qunit/-embroider-implicit-modules.js";
  import dep22 from "ember-source/-embroider-implicit-modules.js";
  import dep23 from "tracked-built-ins/-embroider-implicit-modules.js";
  import dep24 from "@embroider/macros/-embroider-implicit-modules.js";
  import dep25 from "ember-auto-import/-embroider-implicit-modules.js";
  import dep26 from "@ember-intl/v1-compat/-embroider-implicit-modules.js";
  import dep27 from "@ember/optional-features/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
    dep6,
    dep7,
    dep8,
    dep9,
    dep10,
    dep11,
    dep12,
    dep13,
    dep14,
    dep15,
    dep16,
    dep17,
    dep18,
    dep19,
    dep20,
    dep21,
    dep22,
    dep23,
    dep24,
    dep25,
    dep26,
    dep27,
  {
  }
);
